import { useState } from "react";
import { Botao, cx } from "../../components/ui.js";
import { comandoDeInstalacaoNoLinux, enderecoDoAgente } from "./impressora.js";

/**
 * Onde baixar o agente de impressão (#109): o `.exe` no Windows, e no Linux a linha que instala e abre, para colar
 * no terminal. Aparece na lista de impressoras e no passo 1 de "Ligar o agente".
 *
 * Os executáveis são públicos: não guardam segredo nenhum — o que liga o agente a uma impressora é o código, que
 * só o admin gera. Por isso a linha do Linux funciona num terminal, sem a sessão do navegador.
 */
export function DownloadsDoAgente({ className }: { className?: string }) {
  const origem = window.location.origin;
  const comando = comandoDeInstalacaoNoLinux(origem);
  const [copiado, setCopiado] = useState<"sim" | "falhou" | null>(null);

  async function copiar() {
    try {
      await navigator.clipboard.writeText(comando);
      setCopiado("sim");
    } catch {
      // Sem permissão de área de transferência (http, navegador antigo): o comando está na tela para selecionar.
      setCopiado("falhou");
    }
    setTimeout(() => setCopiado(null), 2500);
  }

  return (
    <div className={cx("flex flex-col gap-4", className)}>
      <div className="flex flex-col gap-2">
        <p className="text-[0.875rem] font-medium text-texto">Windows</p>
        <a
          href={enderecoDoAgente(origem, "windows")}
          download
          className={cx(
            "inline-flex min-h-11 items-center justify-center self-start rounded-peca px-4 py-3",
            "text-[0.9375rem] leading-none tracking-[-0.01em] transition-colors",
            "border border-borda bg-superficie-alta text-texto hover:bg-borda",
          )}
        >
          Baixar o agente (.exe)
        </a>
      </div>

      <div className="flex flex-col gap-2">
        <p className="text-[0.875rem] font-medium text-texto">Linux, no terminal</p>
        <pre className="rounded-peca border border-borda bg-fundo px-3 py-2.5 font-mono text-[0.75rem] leading-relaxed whitespace-pre-wrap break-all text-texto">
          {comando}
        </pre>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
          <Botao tom="quieto" className="min-h-11" onClick={() => void copiar()}>
            {copiado === "sim" ? "Copiado" : "Copiar o comando"}
          </Botao>
          <a
            href={enderecoDoAgente(origem, "linux")}
            download
            className="text-[0.8125rem] text-texto-suave underline underline-offset-2 hover:text-texto"
          >
            ou baixe o arquivo
          </a>
        </div>
        {copiado === "falhou" && (
          <p className="text-[0.8125rem] text-texto-suave">
            Não deu para copiar daqui: selecione a linha acima e copie.
          </p>
        )}
      </div>

      <p className="text-[0.8125rem] leading-relaxed text-texto-suave">
        São cerca de 90 MB: baixe antes do evento, num Wi-Fi, e não pela internet do celular.
      </p>
    </div>
  );
}
